import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type DriverInitialStateType = {
  phoneNumber: string
  driverName: string
}

const initialState: DriverInitialStateType = {
  phoneNumber: '',
  driverName: '',
}

const DriverSlice = createSlice({
  name: 'driverSlice',
  initialState,
  reducers: {
    commitDriverPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload
    },
    commitDriverName: (state, action: PayloadAction<string>) => {
      state.driverName = action.payload
    },
  },
})

export const { commitDriverPhoneNumber, commitDriverName } = DriverSlice.actions

export default DriverSlice.reducer
